<template>
  <div class="card mb-4" v-if="simpleFields.length">
    <div class="card-header bg-info text-white">
      <h5 class="fs-6">Datos Propios del Evento</h5>
    </div>
    <div class="card-body">
      <div class="row">
        <component
          v-for="field in simpleFields"
          :is="resolveComponent(field)"
          :key="field.name"
          v-bind="fieldProps(field)"
          :class="columnClass"
        />
        <component
          v-for="field in optionFields"
          :is="resolveComponent(field)"
          :key="field.name"
          v-bind="fieldProps(field)"
          :class="optionColumnClass"
        />
      </div>
    </div>
  </div>
</template>
<script setup>
import { computed } from "vue";
import { buildValidationRules, createValidationFunction } from "@/form_builder/utils/ValidationRulesForm";
import TextInputField from "@/components/dynamicForms/typeText.vue";
import NumberInputField from "@/components/dynamicForms/typeNumber.vue";
import PasswordInputField from "@/components/dynamicForms/typePassword.vue";
import TextareaField from "@/components/dynamicForms/typeArea.vue";
import SelectField from "@/components/dynamicForms/typeSelect.vue";
import SliderField from "@/components/dynamicForms/typeSlider.vue";
import SwitchField from "@/components/dynamicForms/typeSwitch.vue";
import TimeField from "@/components/dynamicForms/typeTime.vue";
import FileUploadField from "@/components/dynamicForms/typeDoc.vue";
import ImageUploadField from "@/components/dynamicForms/typeImg.vue";
import CheckboxField from "@/components/dynamicForms/typeCheck.vue";
import RadioField from "@/components/dynamicForms/typeRadio.vue";
import TypeURL from "@/components/dynamicForms/typeUrl.vue";

const props = defineProps({
  schema: {
    type: Object,
    required: true,
  },
});

function resolveComponent(field) {
  if (field.as === "link") {
    return TypeURL;
  }
  if (field.as === "input") {
    if (field.uploadType === "file") return FileUploadField;
    if (field.uploadType === "image") return ImageUploadField;
    if (field.type === "password") return PasswordInputField;
    if (field.type === "textarea") return TextareaField;
    if (field.type === "number") return NumberInputField;
    return TextInputField;
  } else if (field.as === "number") {
    return NumberInputField;
  } else if (field.as === "select") {
    return SelectField;
  } else if (field.as === "slider") {
    return SliderField;
  } else if (field.as === "switch") {
    return SwitchField;
  } else if (field.as === "time-range") {
    return TimeField;
  } else if (field.as === "checkbox") {
    return CheckboxField;
  } else if (field.as === "radio") {
    return RadioField;
  }
  return TextInputField;
}

const simpleFields = computed(() =>
  props.schema.fields.filter((f) => !["checkbox", "radio"].includes(f.as))
);

const optionFields = computed(() =>
  props.schema.fields.filter((f) => ["checkbox", "radio"].includes(f.as))
);

const columnClass = computed(() => {
  return props.schema.fields.length <= 1 ? "col-12" : "col-lg-6 col-12";
});

const optionColumnClass = computed(() => {
  return optionFields.value.length <= 1 ? "col-12" : "col-lg-6 col-12";
});

function fieldProps(field) {
  const baseProps = {
    id: field.name,
    name: field.name,
    label: field.label,
    required: field.required,
    validationRules: createValidationFunction(buildValidationRules(field)),
  };

  if (field.placeholder) {
    baseProps.placeholder = field.placeholder;
  }

  if (field.children && field.children.length > 0) {
    baseProps.options = field.children;
  }

  if (field.uploadType) {
    baseProps.uploadType = field.uploadType;
  }

  if (field.limit) {
    baseProps.limit = field.limit;
  }

  if (field.type) {
    baseProps.type = field.type;
  }

  if (field.fieldName) {
    baseProps.fieldName = field.fieldName;
  }

  if (field.pattern) {
    baseProps.pattern = field.pattern;
  }

  return baseProps;
}
</script>
